export const catalogRoutes = [
  {
    name: 'locationBrandCatalogs',
    path: '/location-brands/catalogs',
    component: () => import('@/modules/catalog/views/LocationBrandCatalogs.vue'),
    meta: {
      locationTypes: ['location', 'singleLocation']
    }
  },
  {
    name: 'catalogs',
    path: '/catalogs',
    component: () => import('@/modules/catalog/views/Catalogs.vue')
  },
  {
    name: 'productsCatalog',
    path: '/products',
    component: () => import('@/modules/catalog/views/ProductsCatalog.vue')
  },
  {
    name: 'modifiersCatalog',
    path: '/modifiers',
    component: () => import('@/modules/catalog/views/ModifiersCatalog.vue')
  },
  {
    name: 'combosCatalog',
    path: '/combos',
    component: () => import('@/modules/catalog/views/CombosCatalog.vue')
  },
  {
    name: 'catalog',
    path: '/catalogs/:catalogId',
    component: () => import('@/modules/catalog/views/Catalog.vue')
  },
  {
    name: 'translations',
    path: '/translations',
    component: () => import('@/modules/catalog/views/Translations.vue'),
    meta: {
      locationTypes: ['organization', 'singleLocation']
    }
  },
  {
    name: 'translation',
    path: '/translations/:from/:to',
    component: () => import('@/modules/catalog/views/Translation.vue'),
    meta: {
      locationTypes: ['organization', 'singleLocation']
    }
  }
]
